import React, { useState } from "react";

function WhatsApp() {
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [recipients, setRecipients] = useState("");
  const [customMessage, setCustomMessage] = useState("");
  const [sent, setSent] = useState([]);

  const templates = [
    {
      name: "Daily Gold Rate",
      message: `🌟 *Today's Gold Rate — Swarna*\n22K: ₹6,842/g (▲₹48)\n24K: ₹7,456/g (▲₹52)\n\nBook your order today! Reply to enquire.`,
    },
    {
      name: "Scheme Payment Reminder",
      message: `⚠️ *Payment Reminder — Swarna*\n\nDear Customer,\nYour monthly scheme payment is due today.\n\nAmount: ₹5,000\nScheme: Gold SIP 12M\n\nPlease make the payment at your earliest. Thank you!`,
    },
    {
      name: "Bill Confirmation",
      message: `✅ *Bill Confirmed — Swarna*\n\nDear Customer,\nYour bill has been generated successfully.\n\nBill #: GR-2026-XXXX\nTotal: ₹XXXX\n\nThank you for shopping with us!`,
    },
    {
      name: "Order Ready",
      message: `🎉 *Your Order is Ready — Swarna*\n\nDear Customer,\nYour custom jewelry order is ready for pickup!\n\nOrder #: ORD-XXXX\nItem: XXXX\n\nVisit us during working hours. Thank you!`,
    },
    {
      name: "New Catalog",
      message: `✨ *New Collection Arrived — Swarna*\n\nDear Customer,\nWe have launched our new gold jewelry collection!\n\n🔗 View Catalog: [link]\n\nLimited pieces available. Visit us today!`,
    },
  ];

  const handleTemplateSelect = (t) => {
    setSelectedTemplate(t.name);
    setCustomMessage(t.message);
  };

  const handleSend = () => {
    if (!selectedTemplate || !recipients) {
      alert("Please select a template and recipients");
      return;
    }
    const log = {
      template: selectedTemplate,
      recipients,
      time: new Date().toLocaleTimeString("en-IN"),
      status: "Sent",
    };
    setSent([log, ...sent]);
    alert(`Message sent to ${recipients}!`);
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "13px",
  };
  const labelStyle = {
    fontSize: "12px",
    color: "#403301",
    display: "block",
    marginBottom: "4px",
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "30px",
        color: "#403301",
        background: "f8f9fa",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>WhatsApp</h2>
          <p style={{ margin: 0, color: "#efbf04", fontSize: "12px" }}>
            Send notifications and catalogs
          </p>
        </div>
        <span
          style={{
            background: "#25D366",
            color: "white",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
          }}
        >
          ● Meta Official API
        </span>
      </div>

      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}
      >
        {/* Left - Send Message */}
        <div>
          {/* Templates */}
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "20px",
              marginBottom: "16px",
            }}
          >
            <h3 style={{ marginTop: 0, color: "#403301" }}>
              Message Templates
            </h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                marginBottom: "16px",
              }}
            >
              {templates.map((t, i) => (
                <div
                  key={i}
                  onClick={() => handleTemplateSelect(t)}
                  style={{
                    padding: "10px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    background:
                      selectedTemplate === t.name ? "#856A00" : "#C2B067",
                    color: selectedTemplate === t.name ? "gold" : "#403301",
                    fontSize: "13px",
                    border: "1px solid #856A00",
                  }}
                >
                  {t.name}
                </div>
              ))}
            </div>

            <div>
              <label style={labelStyle}>Recipients</label>
              <select
                value={recipients}
                onChange={(e) => setRecipients(e.target.value)}
                style={inputStyle}
              >
                <option value="">Select group</option>
                <option>All Customers</option>
                <option>Scheme Members</option>
                <option>Premium Customers</option>
              </select>
            </div>
          </div>

          {/* Preview */}
          {customMessage && (
            <div
              style={{
                background: "#928243",
                border: "1px solid #856A00",
                borderRadius: "10px",
                padding: "20px",
                marginBottom: "16px",
              }}
            >
              <h3 style={{ marginTop: 0, color: "#403301" }}>
                Message Preview
              </h3>
              <textarea
                value={customMessage}
                onChange={(e) => setCustomMessage(e.target.value)}
                style={{
                  width: "100%",
                  background: "#C2B067",
                  borderRadius: "8px",
                  padding: "12px",
                  fontSize: "13px",
                  color: "#403301",
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.6",
                  border: "1px solid #856A00",
                  resize: "vertical",
                  minHeight: "120px",
                  fontFamily: "Arial",
                  boxSizing: "border-box",
                }}
              />
              <button
                onClick={handleSend}
                style={{
                  marginTop: "12px",
                  width: "100%",
                  background: "#25D366",
                  color: "white",
                  border: "none",
                  padding: "10px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                📤 Send Message
              </button>
            </div>
          )}
        </div>

        {/* Right - Logs + Catalog */}
        <div>
          {/* Send Log */}
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "20px",
              marginBottom: "16px",
            }}
          >
            <h3 style={{ marginTop: 0, color: "#403301" }}>Recent Sends</h3>
            {sent.length === 0 ? (
              <div
                style={{
                  color: "#403301",
                  fontSize: "13px",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                No messages sent yet
              </div>
            ) : (
              sent.map((s, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px",
                    background: "#C2B067",
                    borderRadius: "8px",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "#25D366",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  >
                    💬
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#403301",
                        fontWeight: "500",
                      }}
                    >
                      {s.template} → {s.recipients}
                    </div>
                    <div style={{ fontSize: "11px", color: "#856A00" }}>
                      {s.time} · {s.status}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Catalog */}
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <h3 style={{ marginTop: 0, color: "#403301" }}>Catalog Creation</h3>
            <p style={{ fontSize: "13px", color: "#403301", marginTop: 0 }}>
              Auto-generate WhatsApp catalog from inventory
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px",
                marginBottom: "12px",
              }}
            >
              <div>
                <label style={labelStyle}>Category</label>
                <select style={inputStyle}>
                  <option>All</option>
                  <option>Ring</option>
                  <option>Necklace</option>
                  <option>Bangle</option>
                  <option>Earring</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Purity</label>
                <select style={inputStyle}>
                  <option>All</option>
                  <option>22K</option>
                  <option>24K</option>
                  <option>18K</option>
                </select>
              </div>
            </div>
            <button
              style={{
                width: "100%",
                background: "#856A00",
                color: "gold",
                border: "none",
                padding: "10px",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "13px",
              }}
              onClick={() =>
                alert(
                  "Catalog generation requires Meta API approval. Coming soon!",
                )
              }
            >
              Generate Catalog ↗
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatsApp;
